
export class SearchData {
  readonly searchTerm: string;
  readonly companyId: string;
  readonly objectId: string | undefined;
  readonly type: string | undefined;

  constructor(companyId: string, searchTerm: string, objectId?: string, type?: string) {
console.log("SearchData: companyId: " + companyId + ", searchTerm: " + searchTerm + ", objectId: " + objectId + ", type: " + type);
    this.searchTerm = searchTerm;
    this.companyId = companyId;
    this.objectId = objectId;
    this.type = type;
  }
}